module.exports = __webpack_public_path__ + "static/logo-talk-of-the-town-c1ae45e3eea58b134833cdcc972d5179.svg";